import {
  setHospitalAdmin,
  setHospitalSynchronizedAt,
  setToken,
  setLoggedUser,
  setUserProfile,
  removeToken,
  setManagedHospitals,
  setSelectedHospitalId,
  getSelectedHospitalId,
} from './auth'
import * as userApi from './api.client'
import * as hospitalAdminApi from '../adminHospital/api.client'
import { UserRole } from './types'

export class LoginRoleNotAllowedError extends Error {
  constructor(message = 'Login externo disponível apenas para médicos.') {
    super(message)
    this.name = 'LoginRoleNotAllowedError'
  }
}

export const completeLogin = async (
  token: string,
  handleSuccessfulLogin: () => void,
  options?: { allowedRoles?: UserRole[] }
) => {
  setToken(token)

  const user = await userApi.get()

  if (
    options?.allowedRoles?.length &&
    !options.allowedRoles.includes(user.role)
  ) {
    removeToken()
    throw new LoginRoleNotAllowedError()
  }

  if (user.role === UserRole.HOSPITAL_ADMIN) {
    const managedHospitals = await hospitalAdminApi.getManagedHospitals()
    setManagedHospitals(managedHospitals)

    const storedHospitalId = getSelectedHospitalId()
    const hospitalToSelect =
      managedHospitals.find(
        (item) => item.hospitalId === storedHospitalId
      ) ?? managedHospitals[0]

    if (hospitalToSelect) {
      setSelectedHospitalId(hospitalToSelect.hospitalId)
      setHospitalAdmin(hospitalToSelect.hospital)

      try {
        const sync = await hospitalAdminApi.getHospitalSynchronizedAt(
          hospitalToSelect.hospitalId
        )
        const ms = Number(sync.sincronizedAt)
        if (Number.isFinite(ms)) {
          setHospitalSynchronizedAt(ms)
        }
      } catch (e) {
        console.error(e)
      }
    }
  }

  setUserProfile(user.role)
  setLoggedUser(user)

  handleSuccessfulLogin()
}
